import Vue from 'vue'
import App from './App.vue'

import router, { routerHelper } from './router'
import { store, systemStore, teacherStore, menuRoleStore } from 'kuaidong-store'

import './assets/icons'
import 'mint-ui/lib/style.css'
import './assets/style/reset.css'
import './assets/style/global.less'
import './assets/style/kuaidong-ui.less'
import 'slider-verify-v2/lib/SliderVerify.css'
import 'github-markdown-css/github-markdown-light.css'
// 手势缩放样式
import 'photoswipe/style.css'

import SliderVerify from 'slider-verify-v2'
import { KdIcon, KDMessageBox } from 'kuaidong-ui'
import { InfiniteScroll, Lazyload } from 'mint-ui'

import LoginService from './services/LoginService'
import { PermissionService, TitleBar } from 'kuaidong-service'
import { syncTitleBarByRouteMeta } from './router/titleBar'

import {
  logger,
  UIUtil,
  AppUtil,
  VueUtil,
  EnvUtil,
  HttpUtil,
  eventBus,
  BrowserUtil,
  AppUtilEvent,
  HttpUtilEvent,
  IBackInterceptorParams,
} from 'kuaidong-lib'

router.beforeEach(LoginService.routerBeforeEachHook.bind(LoginService))
router.beforeEach((_to, _from, _next) => {
  syncTitleBarByRouteMeta(_to.meta, _from.meta)
  _next()
})

AppUtil.init()
AppUtil.on(AppUtilEvent.Auth, LoginService.routeToAuth.bind(LoginService))
AppUtil.on(AppUtilEvent.Login, LoginService.login.bind(LoginService, undefined))

let backInterceptorMessageBoxOpening = false
AppUtil.registerBackInterceptor(async (_params: IBackInterceptorParams) => {
  if (backInterceptorMessageBoxOpening) {
    return false
  }

  if (!_params.canGoBack) {
    backInterceptorMessageBoxOpening = true
    const ok = await KDMessageBox.confirm('', '是否退出体智云？')
    backInterceptorMessageBoxOpening = false

    return !!ok
  }

  return true
})

VueUtil.setRemByMainEleId('app')
VueUtil.addVConsole()
VueUtil.setARMSConfig({ environment: EnvUtil.isProd() ? 'prod' : 'gray' })

Vue.use(Lazyload)
Vue.use(SliderVerify)
Vue.use(InfiniteScroll)
Vue.component('kd-icon', KdIcon)
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.px = Vue.prototype.$px = VueUtil.getActualPx.bind(VueUtil)
Vue.bus = Vue.prototype.$bus = eventBus
Vue.routerHelper = Vue.prototype.$routerHelper = routerHelper

logger.init()
TitleBar.init()
systemStore.init()

Vue.mixin({
  computed: {
    $p() {
      return new PermissionService(
        teacherStore.userRoleInfo,
        teacherStore.teacher,
        menuRoleStore.menuRole
      ).buildPermissions()
    },

    $isWeapp() {
      return BrowserUtil.isWeapp()
    },

    $isWechat() {
      return BrowserUtil.isWechat()
    },

    $isUnderApp() {
      return systemStore.isUnderApp
    },
  },
})

HttpUtil.setWithCredentials()
HttpUtil.on(HttpUtilEvent.BeforeRequest, () => UIUtil.showLoading())
HttpUtil.on(HttpUtilEvent.AfterRequest, () => UIUtil.hideLoading())
HttpUtil.on(HttpUtilEvent.StatusCode401, () => LoginService.login())

const v = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

logger.installCodelessTracking(v)
